import { Helmet } from "react-helmet-async";

import { useEffect, useState } from "react";
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TableHead,
  CircularProgress,
  Box,
  Grid,
} from "@mui/material";

// components

import Iconify from "../components/iconify";
import Scrollbar from "../components/scrollbar";

import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
// ----------------------------------------------------------------------

export default function QuestionTemplatesPage() {
  const [loading, setLoading] = useState(false);
  const [playerTemplates, setPlayerTemplates] = useState(null);
  const [teamTemplates, setTeamTemplates] = useState(null);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/admin/question-templates`)
      .then(function (response) {
        setPlayerTemplates(response.data.playerQuestions);
        setTeamTemplates(response.data.teamQuestions);
      });
  }, []);

  return (
    <>
      <Helmet>
        <title> Bingo Question Templates </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Question Templates
          </Typography>
        </Stack>

        <Card>
          {playerTemplates === null || loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <>
              <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid item xs={6}>
                  <Scrollbar>
                    <TableContainer component={Paper}>
                      <Table sx={{ minWidth: 350 }} aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell>#</TableCell>
                            <TableCell>Text</TableCell>
                            <TableCell>Level</TableCell>
                            <TableCell>Score Type</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {playerTemplates.map((row, index) => (
                            <TableRow
                              key={index}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                              <TableCell component="th" scope="row">
                                {index + 1}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                Player {row.value} {row.text}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {row.level}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {row.scoreStrategy}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Scrollbar>
                </Grid>
                <Grid item xs={6}>
                  <Scrollbar>
                    <TableContainer component={Paper}>
                      <Table sx={{ minWidth: 350 }} aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell>#</TableCell>
                            <TableCell>Text</TableCell>
                            <TableCell>Level</TableCell>
                            <TableCell>Score Type</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {teamTemplates.map((row, index) => (
                            <TableRow
                              key={index}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                              <TableCell component="th" scope="row">
                                {index + 1}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                Team {row.value} {row.text}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {row.level}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {row.scoreStrategy}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Scrollbar>
                </Grid>
              </Grid>
            </>
          )}
        </Card>
      </Container>
    </>
  );
}
